
import { ROOT_ACTIONS } from "@/store/actions";
import { Component, Vue } from "vue-property-decorator";
import { ContentItem } from "@/types";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { firestore } from "@/firebase";
import { USER_GETTERS } from "@/store/user/getters";

@Component({
  components: {
    UploadContentDialog: () => import('@/components/dialogs/UploadContentDialog.vue')
  }
})
export default class Index extends Vue {

  items: ContentItem[] = [];

  get isAdmin() {
    const user = this.$store.getters[USER_GETTERS.ACTING_USER]
    return user.type === 'ADMIN'
  }

  loading = false;

  dialogs = {
    upload: false,
  }

  async fetchItems() {
    try {
      const items = await getDocs(query(collection(firestore, 'content-items'), where('archived', '==', false), orderBy('title')));

      this.items = items.docs.map(e => ({
        ...e.data(),
        id: e.id
      } as ContentItem))


    } catch (error) {
      console.log(error)
      this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
        color: 'error',
        text: error
      })
    } finally {
      this.loading = false;
    }

  }

  async mounted() {
    this.$store.dispatch(ROOT_ACTIONS.SET_BREADCRUMBS, [{ text: 'Bibliotheek', target: 'libary' }])
    this.fetchItems();
  }
}
